import ready, { HTML } from './utils';
import AOS from 'aos';
import initSlider from './components/initSlider'; 
import initVideoPlayer from './components/initVideoPlayer';
import initAccordion from './components/initAccordion';
import initburgerMenu from './components/initburgerMenu';
import initHeaderHideShow from './components/initHeaderHideShow';
import initYoutubePlayer from './components/initYoutubePlayer';
import initFancybox from './components/initFancybox';
import initSelect from './components/initSelect';
import initUsingMouse from './components/initUsingMouse';
import initTextResize from './components/textResize';
import initPopup from './components/initPopup';
import initElementHeight from './components/initElementHeight';
import initCustomHover from './components/initCustomHover';
import initHoverlink from './components/hoverLinks';
import initLoadMore from './components/initLoadMore';

ready(() => {
  HTML.classList.add('is-loaded');
  initSlider();
  initVideoPlayer();
  initYoutubePlayer();
  initAccordion();
  initburgerMenu();
  initFancybox();
  initSelect();
  initUsingMouse();
  initLoadMore();
  initTextResize();
  initPopup();
  initElementHeight();
  initCustomHover();
  initHoverlink()
  AOS.init();
  initGlink();
  setTimeout(()=>{
    initHeaderHideShow();
  },100)
});

function initGlink() {
  const body = document.body;
  const wrapper = body.querySelector('.gtranslate_wrapper');
  if(!wrapper) return;
  const opener = wrapper.querySelector('.gt_switcher-popup');
  const overlay = wrapper.querySelector('.gt_black_overlay');
  const element = wrapper.querySelector('.gt_white_content');
  const items = element.querySelectorAll('.glink');

  opener.addEventListener('click', function(){
      if(element.style.display === 'block') {
          body.classList.add('gtranslate-active');
      } else {
          body.classList.remove('gtranslate-active');
      }
  })

  overlay.addEventListener('click', function(){
      body.classList.remove('gtranslate-active');
  })

  items.forEach((item) => {
      item.addEventListener('click', function(){
          body.classList.remove('gtranslate-active');
      })
  })
}